import { IUsuarioResponse } from '../models/interfaces';
import http from '../utils/http';

export const usuariosService = async () => {
	const response = await http.get<IUsuarioResponse[]>(
		'ObraProyectoUser/GetUsuariosMonitor'
	);
	return response;
};
